const AUTH_PUBLIC_PATHS = [
  '/login',
  '/forgot-password',
  '/api/auth/callback',
] as const;

export function isPublicAuthPath(path: string): boolean {
  return (AUTH_PUBLIC_PATHS as readonly string[]).includes(path);
}
